{
  "name": "sheba.web",
  "version": "0.30.01",

  
  "scripts": {
    "ng": "ng",
    "start": "ng serve --configuration local --ssl",
    "build": "ng build",
    "build-dev": "ng build --configuration development --aot",
    "build-test": "ng build --configuration test --aot",
    "build-prod": "ng build --configuration prod --aot",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^17.3.0",
    "@angular/cdk": "^17.3.7",
    "@angular/common": "^17.3.0",
    "@angular/compiler": "^17.3.0",
    "@angular/core": "^17.3.0",
    "@angular/forms": "^17.3.0",
    "@angular/localize": "^17.3.0",
    "@angular/material": "^17.3.7",
    "@angular/platform-browser": "^17.3.0",
    "@angular/platform-browser-dynamic": "^17.3.0",
    "@angular/platform-server": "^17.3.0",
    "@angular/router": "^17.3.0",
    "@angular/ssr": "^17.3.2",
    "@angular/youtube-player": "^17.3.10",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "clsx": "^2.1.1",
    "dayjs": "^1.11.10",
    "lottie-web": "^5.12.2",
    "ng-recaptcha": "^13.2.1",
    "ngx-lottie": "^11.0.2",
    "ngx-masonry": "^14.0.1",
    "ngx-sharebuttons": "^15.0.1",
    "rxjs": "~7.8.0",
    "swiper": "^11.1.3",
    "tailwind-merge": "^3.3.1",
    "tslib": "^2.3.0",
    "zone.js": "~0.14.3"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^17.3.2",
    "@angular/cli": "^17.3.2",
    "@angular/compiler-cli": "^17.3.0",
    "@angular/localize": "^17.3.9",
    "@types/express": "^4.17.17",
    "@types/jasmine": "~5.1.0",
    "@types/node": "^18.18.0",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "prettier": "^3.2.5",
    "prettier-plugin-organize-attributes": "^1.0.0",
    "prettier-plugin-organize-imports": "^3.2.4",
    "prettier-plugin-tailwindcss": "^0.5.14",
    "tailwind-scrollbar": "^3.1.0",
    "tailwindcss": "3.4.17",
    "typescript": "~5.4.2"
  }
}
